require('./src/assets/scss/main.scss');
require('prismjs/themes/prism-solarizedlight.css');

// Called when prefetching for a pathname is triggered.
// We use this API hook to make sure our links exist before using them
// eslint-disable-next-line import/prefer-default-export
export const onPostPrefetchPathname = () => {
  // We get the reference to the favicon links we need to update
  const favicon32 = document.getElementById('favicon32');
  const favicon192 = document.getElementById('favicon192');
  const favicon180 = document.querySelector('link[rel=apple-touch-icon]');

  // Switch favicon if dark/light theme changes on the user's device
  function switchIcon(usesDarkMode) {
    if (usesDarkMode) {
      favicon32.href = '/favicon-dark-32.png';
      favicon180.href = '/favicon-dark-180.png';
      favicon192.href = '/favicon-dark-192.png';
    } else {
      favicon32.href = '/favicon-light-32.png';
      favicon180.href = '/favicon-light-180.png';
      favicon192.href = '/favicon-light-192.png';
    }
  }

  // Check to see if the user has dark mode enabled
  const usesDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches || false;

  // Run the switchIcon function if the user's color scheme changes
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', (e) => switchIcon(e.matches));

  // We always start with light-themed favicons, so we need to update
  //  if the user has dark mode enabled
  switchIcon(usesDarkMode);
};

/**
 * The following section helps us manage when images are tall and skinny.
 * We would normally see this in a blog post or product update post that
 * might show a screenshot from a mobile device.
 */

/* eslint-disable no-param-reassign */
const capTallImages = () => {
  const MAX_HEIGHT = window.innerHeight * 0.6;
  document
    .querySelectorAll(
      '.release-body .gatsby-resp-image-wrapper, .blog-post-body .gatsby-resp-image-wrapper',
    )
    .forEach((wrapper) => {
      const bg = wrapper.querySelector('.gatsby-resp-image-background-image');
      if (!bg) return;

      // Store the original padding-bottom the first time we see this element
      if (!bg.dataset.naturalPadding) {
        bg.dataset.naturalPadding = bg.style.paddingBottom;
      }

      // Reset
      bg.style.paddingBottom = bg.dataset.naturalPadding;
      bg.style.height = '';
      wrapper.style.maxHeight = '';
      wrapper.style.width = '';

      const naturalPadding = parseFloat(bg.dataset.naturalPadding);
      const wrapperWidth = wrapper.offsetWidth;
      const naturalHeight = (naturalPadding / 100) * wrapperWidth;

      if (naturalHeight > MAX_HEIGHT) {
        const aspectRatio = wrapperWidth / naturalHeight;
        const cappedWidth = MAX_HEIGHT * aspectRatio;

        bg.style.paddingBottom = '0';
        bg.style.height = `${MAX_HEIGHT}px`;
        wrapper.style.maxHeight = `${MAX_HEIGHT}px`;
        wrapper.style.width = `${cappedWidth}px`;
      }
    });
};
/* eslint-enable no-param-reassign */

let resizeTimer;

const debouncedCap = () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(capTallImages, 150);
};

export const onRouteUpdate = () => {
  capTallImages();
  window.addEventListener('resize', debouncedCap);
};
